export function buildProjectDeepLinkQuery({ currentQuery = {}, deepLinkQuery = {}, projectId }) {
  const projectQuery = projectId !== undefined && projectId !== null ? { switch_project_id: projectId } : {}

  return {
    ...currentQuery,
    ...deepLinkQuery,
    ...projectQuery
  }
}
